// 강아지 관련 흥미로운 사실 모음
const dogFactsList = [
  "강아지의 코 지문은 사람의 지문처럼 각각 고유합니다.",
  "강아지는 인간보다 약 40배 더 예민한 후각을 가지고 있습니다.",
  "달마시안 강아지는 태어날 때 흰색이며, 점은 나이가 들면서 생깁니다.",
  "강아지의 청력은 인간보다 약 4배 더 예민합니다.",
  "평균적으로 강아지는 약 10,000개의 단어를 이해할 수 있습니다.",
  "강아지는 땀을 발바닥으로만 흘립니다.",
  "그레이하운드는 최대 시속 72km까지 달릴 수 있는 세계에서 가장 빠른 개입니다.",
  "강아지의 체온은 평균 38.3°C로 인간보다 약간 높습니다.",
  "강아지는 색맹이 아니지만, 인간보다 더 적은 색상을 볼 수 있습니다.",
  "강아지의 심장 박동수는 분당 70-120회로, 크기에 따라 다릅니다.",
  "강아지는 꿈을 꿀 수 있으며, 꿈을 꿀 때 다리를 움직이거나 소리를 낼 수 있습니다.",
  "강아지의 수명은 품종에 따라 7-18년까지 다양합니다.",
  "세계에서 가장 작은 개 품종은 치와와이며, 가장 큰 품종은 그레이트 데인입니다.",
  "강아지는 인간의 감정을 읽을 수 있으며, 얼굴 표정을 해석할 수 있습니다.",
  "강아지는 인간과 함께 살아온 최초의 가축 동물 중 하나입니다.",
  "강아지는 약 15,000년 전에 늑대로부터 가축화되었습니다.",
  "강아지의 코는 습기가 있을 때 냄새를 더 잘 맡을 수 있습니다.",
  "강아지는 인간의 질병을 감지할 수 있으며, 의료 분야에서 활용되고 있습니다.",
  "강아지는 꼬리를 흔드는 방향으로 감정을 표현합니다.",
  "강아지는 약 300개의 단어를 이해할 수 있습니다.",
  "강아지의 발바닥에서 나는 냄새는 '프리토스 냄새'라고도 불립니다.",
  "강아지는 인간의 목소리를 들을 때 왼쪽 뇌를 사용합니다.",
  "강아지는 자신의 이름을 알아들을 수 있습니다.",
  "강아지는 인간과 같은 수면 단계를 거칩니다.",
  "강아지는 하품이 전염될 수 있습니다.",
  "강아지는 인간의 감정을 감지하고 공감할 수 있습니다.",
  "강아지는 인간의 호르몬 변화를 감지할 수 있습니다.",
  "강아지는 인간의 시선을 따라갈 수 있는 몇 안 되는 동물 중 하나입니다.",
  "강아지는 인간의 손짓을 이해할 수 있습니다.",
  "강아지는 인간의 감정을 감지하고 반응할 수 있습니다.",
  "강아지는 초콜릿을 먹으면 중독될 수 있습니다.",
  "강아지의 코는 온도 감지 능력도 뛰어납니다.",
  "강아지의 평균 수면 시간은 하루에 12-14시간입니다.",
  "강아지는 다양한 소리를 낼 수 있으며, 그 종류는 최대 100가지 이상입니다.",
  "강아지는 다른 강아지와의 의사소통을 위해 코를 부딪치거나 냄새를 맡습니다.",
  "강아지의 후각은 암을 발견하는 데도 사용됩니다.",
  "강아지는 인간의 스트레스 수준을 낮추는 데 도움이 됩니다.",
  "강아지는 매일 최소 30분 이상의 운동이 필요합니다.",
  "강아지는 자기 몸의 높이보다 약 2배 높은 곳까지 뛰어오를 수 있습니다.",
  "강아지의 꼬리 움직임은 기쁨뿐 아니라 불안함, 긴장감 등 다양한 감정을 나타냅니다.",
  "강아지는 종종 관심을 끌기 위해 일부러 장난을 칩니다.",
  "강아지는 자신의 감정을 표현하기 위해 하품을 하기도 합니다.",
  "강아지는 입맛보다 냄새로 음식을 선택합니다.",
  "강아지는 매일 최소 18시간 이상을 잠이나 휴식을 취하며 보냅니다.",
  "강아지는 물속에서 수영하는 법을 타고난 본능적으로 알고 있습니다.",
  "일부 강아지는 TV 화면의 움직임을 볼 수 있습니다.",
  "강아지의 수염은 감각 기관으로서 주변 환경을 탐지합니다.",
  "강아지는 종종 무리 속에서 사회적 순서를 확립하려 합니다.",
  "강아지는 사람의 미소를 인지하고 긍정적인 반응을 보입니다.",
  "강아지는 사람의 향기를 기억하고 구분할 수 있습니다.",
  "강아지는 잠잘 때 몸을 둥글게 말아 체온을 유지합니다.",
  "강아지의 후각은 사람이 놓친 냄새까지 추적할 수 있습니다.",
  "강아지는 대개 후각을 이용해 길을 찾습니다.",
  "강아지는 맛을 느끼는 미각 세포가 인간보다 훨씬 적습니다.",
  "강아지의 귀 모양은 청력에 큰 영향을 미칩니다.",
  "강아지는 건강한 치아 관리를 위해 뼈나 씹는 장난감을 좋아합니다.",
  "강아지는 주인을 보호하려는 강한 본능을 가지고 있습니다.",
];

// 랜덤 강아지 사실을 가져오는 함수
export function getRandomDogFact() {
  const randomIndex = Math.floor(Math.random() * dogFactsList.length);
  return dogFactsList[randomIndex];
}

// 사용된 인덱스를 추적하지 않고 항상 랜덤한 사실을 반환하도록 수정
export const dogFacts = dogFactsList.slice(); // 원래 배열 참조 유지 (기존 코드 호환성)